export default __webpack_public_path__ + "static/media/background_selfie_screen.7bf2302e.png";